import { Input } from "./input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const SearchBar = ({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
  inputClassName = "",
}) => {
  return (
    <div className={`relative flex-1 ${className}`}>
      <FontAwesomeIcon
        icon={faSearch}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600 h-3.5 w-3.5 sm:h-4 sm:w-4"
      />
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`pl-9 pr-3 py-1.5 h-9 sm:h-10 text-xs sm:text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-800/30 w-full ${inputClassName}`}
      />
    </div>
  );
};

export default SearchBar;
